<br>
<!--div *ngIf="!showMailView" class="form-row btntop col-sm-12 d-flex align-items-center" style="margin-top: 10px;">
  <div class="d-flex justify-content-start">
  <div class="d-flex justify-content-between gap-1">
    <table>
    <tr>
      <td>
        <button class="btn border" (click)="search()">Sök</button>
      </td>
      <td>
        <button class="btn border" (click)="clear()">Rensa</button>
      </td>
      <td>
        <button class="btn border" (click)="expanded = !expanded;expandedlabel==='Stäng grupper'? expandedlabel='Öppna grupper' : expandedlabel='Stäng grupper'">{{expandedlabel}}</button>
      </td>
    </tr>
  </table>
  <p class="reportlabel">Rapport: Uppdrag/Ämbeten</p>
  </div>
  </div>
</div-->

<div *ngIf="!showMailView" class="form-row btntop col-sm-11 d-flex align-items-center" style="margin-top: 10px;">
  <div class="d-flex justify-content-start w-100">
    <div class="d-flex align-items-center gap-2 w-100">
      
      <!-- Knapparna -->
      <div class="d-flex gap-1">
        <button class="btn border" (click)="search()">Sök</button>
        <button class="btn border" (click)="clear()">Rensa</button>
        <button class="btn border" (click)="expanded = !expanded; expandedlabel = expandedlabel === 'Stäng grupper' ? 'Öppna grupper' : 'Stäng grupper'">{{ expandedlabel }}</button>
      </div>

      <!-- Labeln -->
      <p class="reportlabel mb-0 ms-3">Rapport: Uppdrag/Ämbeten</p>

    </div>
  </div>
</div>





<form [formGroup]="officereportform" (keydown.enter)="search()">
  <div *ngIf="!showMailView" class="col-xs-11 col-md-11 col-xl-11 ms-4 me-4">
    <div class="row">
      <div class="col-md-6">
        <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title>
              Ämbete
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="row">
            <div class="form-group col-md-6">
              <label for="officeTypeId">
                Ämbetstyp
              </label>
              <select class="form-control form-control-sm" id="officeTypeId" formControlName="officeTypeId" (change)="getOfficesByOfficeType($event)">
                <option></option>
                <option *ngFor="let ot of officetypelist" [value]="ot.id">{{ot.name}}</option>
              </select>
            </div>
            <div class="form-group col-md-6">
              <label for="officeId">
                Ämbete
              </label>
              <p-select [options]="officelist" filter="true" [showClear]="true" optionLabel="officeName" [style]="{'width':'100%'}" (onChange)="getCommitteesByOfficeId($event)" appendTo="body"></p-select>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label for="committeeId">
                Utskott
              </label>
              <select class="form-control form-control-sm" id="committeeId" formControlName="committeeId">
                <option></option>
                <option *ngFor="let c of committeelist" [value]="c.id">{{c.name}} &nbsp;({{c.abbreviation}}) </option>
              </select>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-md-6">
              I någon av institutionerna:
              <button class="btn-small btn-primary" style="width:30px;margin-left:4px;" title="Välj institutioner" (click)="displayOfficeInstitutions=true;"><i class="fa fa-plus"></i></button>
              <button class="btn-small btn-primary" style="width:30px;margin-left:4px;" title="Rensa valda institutioner" (click)="selectedofficeinstitutions=[]"><i class="fa fa-times"></i></button>
            </div>
            <div class="col-md-6">
              <table style="border:1px solid lightgrey;border-radius:3px;width:280px;">
                <tr *ngFor="let x of selectedofficeinstitutions">
                  <td>{{x.name}}</td>
                  <td align="right"><i class="fa fa-times" (click)="removeSelectedOfficeInstitution(x.id)" title="Ta bort vald institution"></i></td>
                </tr>
              </table>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-md-6">
              Period började mellan<br>
              <div class="d-flex justify-content-start gap-2">
                
                  <app-calendarnotrequired [form]="officereportform" formName="officeStartPeriodFrom"></app-calendarnotrequired>&nbsp;
                  <app-calendarnotrequired [form]="officereportform" formName="officeStartPeriodTo"></app-calendarnotrequired>
                  <button class="btn btn-primary" (click)="setDate('officeStartPeriodTo', 'officeEndPeriodFrom')">Just nu</button>
                
              </div>
            </div>
            <div class="col-md-6">
              Period slutade mellan<br>
              <div class="d-flex justify-content-start gap-2">
              
                <p-datepicker id="officeEndPeriodFrom" formControlName="officeEndPeriodFrom" appendTo="body" [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true" [yearNavigator]="true"[inputStyle]="{'width':'110px'}" yearRange="1920:2030" dateFormat="yy-mm-dd"></p-datepicker>
              
              <p-datepicker id="officeEndPeriodTo" formControlName="officeEndPeriodTo" appendTo="body" [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true" [yearNavigator]="true" [inputStyle]="{'width':'110px'}" yearRange="1920:2030" dateFormat="yy-mm-dd"></p-datepicker>
            
            </div>
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title>
              E-post
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-md-6">
              Epost1:<br>
              <p-selectButton [options]="epost" formControlName="email1"></p-selectButton>
            </div>
            <br>
            <div class="col-md-6">
              Epost2:<br>
              <p-selectButton [options]="epost" formControlName="email2"></p-selectButton>
            </div>
          </div>
        </mat-expansion-panel>
      </div>
      <div class="col-md-6">
        <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title>
              Medlemskap
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          
          Medlemskap i
          <div class="d-flex justify-content-start align-items-center gap-2 flex-wrap">
            <p-selectButton [options]="someorall" formControlName="membershipSomeOrAll"></p-selectButton>
          <button *ngIf="officereportform.get('membershipSomeOrAll').value" class="btn-small btn-primary" style="width:30px;" (click)="displayMembership=true;">
                      <i class="fa fa-plus"></i>
                    </button>
                    <button *ngIf="officereportform.get('membershipSomeOrAll').value" class="btn-small btn-primary" style="width:30px;" title="Rensa valda institutioner" (click)="membershipselectedinstitutions=[]">
                      <i class="fa fa-times"></i>
                    </button>
             <table style="border:1px solid lightgrey;border-radius:3px;width:280px;">
                    <tr *ngFor="let x of membershipselectedinstitutions">
                      <td>{{x.name}}</td>
                      <td align="right">
                        <i class="fa fa-times" (click)="removeMembershipSelectedInstitution(x.id)" title="Ta bort vald institution"></i>
                      </td>
                    </tr>
                  </table>
          </div>
         
          <div class="row">
            <div class="col-md-12">
              <br>     
              <div>
                    Medlemskap påbörjades mellan
                <div class="form-group">
                     
                    <p-datepicker id="membershipStartedFrom" formControlName="membershipStartedFrom" appendTo="body" [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true" [yearNavigator]="true" [inputStyle]="{'width':'110px'}" yearRange="1920:2030" dateFormat="yy-mm-dd">
                    </p-datepicker>&nbsp;
                    <p-datepicker id="membershipStartedTo" formControlName="membershipStartedTo" appendTo="body" [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true" [yearNavigator]="true" [inputStyle]="{'width':'110px'}" yearRange="1920:2030" dateFormat="yy-mm-dd">
                    </p-datepicker>
                    <button class="btn btn-primary ms-0 ms-md-3" (click)="setDate('membershipStartedTo', 'membershipEndedFrom')">
                      Just nu
                    </button>
                
                </div>
              </div>
              
              <div>
                    Medlemskap avslutades mellan
                
                <div class="form-group">
                  <div class="form-check-inline">
                    <p-datepicker id="membershipEndedFrom" formControlName="membershipEndedFrom" appendTo="body" [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true" [yearNavigator]="true" [inputStyle]="{'width':'110px'}" yearRange="1920:2030" dateFormat="yy-mm-dd">
                    </p-datepicker>&nbsp;
                    <p-datepicker id="membershipEndedTo" formControlName="membershipEndedTo" appendTo="body" [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true" [yearNavigator]="true" [inputStyle]="{'width':'110px'}" yearRange="1920:2030" dateFormat="yy-mm-dd"></p-datepicker>
                  </div>
                </div>
              </div>
              <br>
            </div>
           <br>
                  <span class="ms-1">Icke medlemskap i </span><br>
                  <div class="d-flex justify-content-start align-items-center gap-2 flex-wrap">
                  <p-selectButton [options]="someorall" formControlName="nomembershipSomeOrAll"></p-selectButton>
               
              
                    <button *ngIf="officereportform.get('nomembershipSomeOrAll').value" class="btn-small btn-primary" style="width:30px;" (click)="displayNoMembership=true;">
                      <i class="fa fa-plus"></i>
                    </button>
                    <button *ngIf="officereportform.get('nomembershipSomeOrAll').value" class="btn-small btn-primary" style="width:30px;" title="Rensa valda institutioner" (click)="nomembershipselectedinstitutions=[]">
                      <i class="fa fa-times"></i>
                    </button>
                 
                
               
                  <table style="border:1px solid lightgrey;border-radius:3px;width:280px;">
                    <tr *ngFor="let x of nomembershipselectedinstitutions">
                      <td>{{x.name}}</td>
                      <td align="right">
                        <i class="fa fa-times" (click)="removeNoMembershipSelectedInstitution(x.id)" title="Ta bort vald institution"></i>
                      </td>
                    </tr>
                  </table>
                   </div>
          </div>
              <br>
              <div class="col-md-12">
               
                    Medlemskap påbörjades mellan
                 
                <div class="form-group">
                 
                    <p-datepicker id="nomembershipStartedFrom" formControlName="nomembershipStartedFrom" appendTo="body" [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true" [inputStyle]="{'width':'110px'}" [yearNavigator]="true" yearRange="1920:2030" dateFormat="yy-mm-dd">
                    </p-datepicker>&nbsp;
                    <p-datepicker id="nomembershipStartedTo" formControlName="nomembershipStartedTo" appendTo="body" [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true" [inputStyle]="{'width':'110px'}" [yearNavigator]="true" yearRange="1920:2030" dateFormat="yy-mm-dd">
                    </p-datepicker>
                    <button class="btn btn-primary ms-0 ms-md-3" (click)="setDate('nomembershipStartedTo', 'nomembershipEndedFrom')">
                      Just nu
                    </button>
                 
                </div>
              </div>
              <br>
              <div>
                
                    Medlemskap avslutades mellan
                
                <div class="form-group col-md-12">
                  <div class="form-check-inline">
                    <p-datepicker id="nomembershipEndedFrom" formControlName="nomembershipEndedFrom" appendTo="body" [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true" [inputStyle]="{'width':'110px'}" [yearNavigator]="true" yearRange="1920:2030" dateFormat="yy-mm-dd">
                    </p-datepicker>&nbsp;
                    <p-datepicker id="nomembershipEndedTo" formControlName="nomembershipEndedTo" appendTo="body" [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true" [inputStyle]="{'width':'110px'}" [yearNavigator]="true" yearRange="1920:2030" dateFormat="yy-mm-dd">
                    </p-datepicker>
                  </div>
                </div>
              </div>
            
            
    

      
          
        </mat-expansion-panel>
      </div>
    </div>
  </div>
</form>
<br>
<div *ngIf="!showMailView && result?.length > 0" class="ms-2 me-2">
  <p-menubar [model]="items">
    <div class="d-flex justify-content-end align-items-center gap-2">
      <span>
        Resultat: {{result?.length}}
      </span>
      <span>
        Välj alla:
        <mat-checkbox #checkAll (change)="checkuncheckAll(checkAll);"></mat-checkbox>
      </span>
    </div>
  </p-menubar>
  <div class="resultdiv" style="margin-top:-6px;">
    <table matSort class="table table-bordered" (matSortChange)="sortData($event)" matSortDisableClear=true>
      <thead role="rowgroup">
        <tr>
          <th mat-sort-header="memberId">Nr</th>
          <th mat-sort-header="givenName">Förnamn</th>
          <th mat-sort-header="familyName">Efternamn</th>
          <th mat-sort-header="memberInstitutionShortName">Inst.</th>
          <th mat-sort-header="officeInstitutionShortName">Ämb. Inst.</th>
          <th mat-sort-header="officeInstitutionVisitingCity">Ort</th>
          <th mat-sort-header="officeName">Ämbete</th>
          <th mat-sort-header="committeeName">Utskott</th>
          <th mat-sort-header="officeStartDate">Fr.o.m.</th>
          <th mat-sort-header="officeEndDate">T.o.m.</th>
          <th mat-sort-header="email">Välj</th>
        </tr>
      </thead>
      <tr *ngFor="let r of result">
        <td style="text-align: right;">
          <a [routerLink]="['/memberform/id/', r.memberId]">{{r.memberId}}</a>
        </td>
        <td>{{r.givenName}}</td>
        <td>{{r.familyName}}</td>
        <td>{{r.officeInstitutionShortName}}</td>
        <td><a [routerLink]="['/institutions/id/', r.memberInstitutionId]" title="Titta på institutionsdetaljer">{{r.officeInstitutionName}}</a></td>
        <td>{{r.officeInstitutionVisitingCity}}</td>
        <td>{{r.officeName}}</td>
        <td>{{r.committeeName}}</td>
        <td>{{r.officeStartDate | date: 'yyyy-MM-dd'}}</td>
        <td>{{r.officeEndDate | date: 'yyyy-MM-dd'}}</td>
        <td>
          <div class="d-flex justify-content-start gap-2">
            <mat-checkbox *ngIf="r.memberInstitutionShortName!=='AV1' && r.checkbox" #inputEl1 (change)="add(r, inputEl1);" [checked]="r.checked"></mat-checkbox><i *ngIf="r.email && r.memberInstitutionShortName!=='AV1' && r.checkbox" class="fa fa-envelope-o mt-2" aria-hidden="true"></i>
          </div>
        </td>
      </tr>
    </table>
  </div>
</div>
<div *ngIf="showMailView">
  <app-mail [memberlist]=selectedmembers (closeEmail)="closeEmail($event)"></app-mail>
</div>

<p-dialog header="Medlemskap i" [(visible)]="displayMembership" [modal]="true" [style]="{'min-width':'800px', 'min-height':'500px'}" [baseZIndex]="10000" [draggable]="true" [resizable]="true" [maximizable]="true" appendTo="body">
  <app-institution-chooser [selectedinstitutions]="membershipselectedinstitutions" [form]="officereportform" (institutionSelected)="setSelectedInstitutions($event, 'membership')"></app-institution-chooser>
</p-dialog>

<p-dialog header="Icke medlemskap i" [(visible)]="displayNoMembership" [modal]="true" [style]="{width:'800px'}"
          [baseZIndex]="10000" [draggable]="true" [resizable]="true" [maximizable]="true" appendTo="body">
  <app-institution-chooser [selectedinstitutions]="nomembershipselectedinstitutions" [form]="officereportform"
                           (institutionSelected)="setSelectedInstitutions($event, 'nomembership')"></app-institution-chooser>
</p-dialog>

<p-dialog header="Välj institution" [(visible)]="displayOfficeInstitutions" [modal]="true" [style]="{width:'800px'}" [baseZIndex]="10000" [draggable]="true" [resizable]="true" [maximizable]="true" appendTo="body">
  <app-institution-chooser [selectedinstitutions]="selectedofficeinstitutions" [form]="officereportform" (institutionSelected)="setSelectedInstitutions($event, 'office')"></app-institution-chooser>
</p-dialog>